module.exports = __webpack_public_path__ + "src/img/help.1c41b18c.svg";